import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Feilgrense } from './components/Feilgrense';
import { startTelemetri } from './lib/telemetri';
import './styles/global.css';
import './styles/app.css';
import './styles/leverandorer.css';

const container = document.getElementById('root');
if (!container) throw new Error('Fant ikke #root i index.html.');

/**
 * Startes uten `await`: overvåkinga skal ikke stå mellom brukeren og sida.
 * Feiler den eller finnes den ikke, tegnes appen like fort som før.
 */
void startTelemetri();

createRoot(container).render(
  <StrictMode>
    {/*
      Feilgrensa ligger utenfor appen, ikke inni. En feil i ruteren eller i
      innloggingskonteksten er nettopp den som gir hvit skjerm, og en grense
      som ligger under dem, ville gått ned sammen med dem.
    */}
    <Feilgrense>
      <App />
    </Feilgrense>
  </StrictMode>,
);
